import { Button, Grid, Paper, TextField } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { AlertTriangle, Home, LayoutDashboard } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Route,
  Routes as Switch,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AdminDashboard from "../components/AdminDashboard";
import Category from "../components/AdminDashboard/Category";
import CommunityAdmin from "../components/AdminDashboard/Community";
import DocumentsAdmin from "../components/AdminDashboard/Documents";
import EducationAdmin from "../components/AdminDashboard/Education";
import EvolutionManager from "../components/AdminDashboard/Evolution";
import KommoConfig from "../components/AdminDashboard/KommoConfig";
import KommoImport from "../components/AdminDashboard/KommoImport";
import ReceiptsAdmin from "../components/AdminDashboard/Receipts/index";
import ComissionsTable from "../components/AdminDashboard/Tables/CommissionsTable/CommissionsTable";
import EventTable from "../components/AdminDashboard/Tables/EventTable/EventTable";
import ExpositorTable from "../components/AdminDashboard/Tables/ExpositorTable/ExpositorTable";
import Gallery from "../components/AdminDashboard/Tables/Gallery";
import PreSubscriptionTable from "../components/AdminDashboard/Tables/PreSubscriptionTable/PreSubscriptionTable";
import SubscriptionTable from "../components/AdminDashboard/Tables/SubscriptionTable/SubscriptionTable";
import WelcomeManager from "../components/AdminDashboard/WelcomeManager";
import ForgotPassword from "../components/ForgotPassword";
import Login from "../components/Login";
import Signup from "../components/Signup";
import UserDashboard from "../components/UserDashboard";
import Commissions from "../components/UserDashboard/Comissions";
import CommunityUser from "../components/UserDashboard/Community";
import Documents from "../components/UserDashboard/Documents";
import EducationUser from "../components/UserDashboard/Education";
import Events from "../components/UserDashboard/Events";
import GalleryUser from "../components/UserDashboard/Gallery";
import PreSubscriptions from "../components/UserDashboard/PreSubscriptions";
import Subscriptions from "../components/UserDashboard/Subscriptions";
import Welcome from "../components/UserDashboard/Welcome";
import { useLoginContext } from "../context/login.context";
import ThemeContainer from "../theme/ThemeProvider";
import { ConfirmProvider } from "../ui-components/ConfirmProvider";
import SectionTitle from "../ui-components/SectionTitle";
import { ToastProvider } from "../ui-components/ToastProvider";
// import { parseDate } from "../utils/parseDate";

// import "react-calendar/dist/Calendar.css";

import logo from "../assets/logo_no_background.png";
import { editPixCode, getPixCode } from "../services/pix.service";
import { useToast } from "../ui-components/ToastProvider";

import { WhatsappRounded } from "@mui/icons-material";
import EventTypes from "../components/AdminDashboard/EventTypes";
import Receipts from "../components/UserDashboard/Receipts";
// import { getAllEvents } from "../services/event.service";

function EventPage() {
  return (
    <>
      <EventTable></EventTable>
    </>
  );
}

function PixPageAdmin() {
  const { showToast } = useToast();
  const [currentPix, setCurrentPix] = useState(null);
  const [newPix, setNewPix] = useState("");

  useEffect(() => {
    getPixCode().then((x) => {
      setCurrentPix(x.pixcode || "Adicione um código Pix");
    });
  }, []);

  const handleClick = () => {
    if (newPix === "" && newPix === currentPix) {
      showToast("Pix inválido ou igual ao anterior", { severity: "warning" });
    } else {
      editPixCode(newPix).then((x) => {
        showToast(
          "Pix alterado com sucesso! A partir de agora os valores de comissão e inscrição serão enviadas para esse Código",
          { severity: "success" }
        );
        console.log(x.newPix.pixcode || "Adicione um código Pix");

        setCurrentPix(x.newPix.pixcode);
      });
    }
  };

  return (
    <Grid sx={{ p: 2, display: "flex", justifyContent: "center" }}>
      {currentPix && (
        <Paper sx={{ p: 3, maxWidth: 480, width: "100%", borderRadius: 2 }}>
          <SectionTitle title="Alterar Chave Pix" />
          <Grid my={2}>
            <TextField
              label="Chave Pix"
              defaultValue={currentPix}
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) => setNewPix(e.target.value)}
            />
          </Grid>
          <Grid>
            <Button
              onClick={handleClick}
              variant="contained"
              size="small"
              fullWidth
            >
              Alterar
            </Button>
          </Grid>
        </Paper>
      )}
    </Grid>
  );
}

function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#24324D] to-[#1a2538] flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#24324D]/10 text-[#24324D] mb-4">
          <AlertTriangle className="w-8 h-8" />
        </div>
        <h1 className="text-4xl font-bold text-[#24324D]">404</h1>
        <p className="text-gray-700 mt-2 font-semibold">
          Página não encontrada
        </p>
        <p className="text-sm text-gray-500 mt-1">
          O link pode estar incorreto ou a página foi movida.
        </p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            startIcon={<Home className="w-4 h-4" />}
          >
            Ir para início
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/dashboard")}
            startIcon={<LayoutDashboard className="w-4 h-4" />}
          >
            Abrir dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function Routes() {
  const { isAdmin } = useLoginContext();

  return (
    <>
      <ScrollToTop />
      <ThemeContainer>
        <ToastProvider>
          <ConfirmProvider>
            <CssBaseline />
            <Switch>
              <Route path="/">
                <Route index element={<Login />} />
                <Route path="login" element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="signup" element={<Signup />} />
                {isAdmin ? (
                  <Route path="dashboard" element={<AdminDashboard />}>
                    <Route index element={<EventPage />} />
                    <Route path="events" element={<EventPage />} />
                    <Route path="expositors" element={<ExpositorTable />} />
                    <Route
                      path="subscriptions"
                      element={<SubscriptionTable />}
                    />
                    <Route
                      path="pre-subscriptions"
                      element={<PreSubscriptionTable />}
                    />
                    <Route path="comissions" element={<ComissionsTable />} />
                    <Route path="gallery" element={<Gallery />} />
                    <Route path="education" element={<EducationAdmin />} />
                    <Route path="documents" element={<DocumentsAdmin />} />
                    <Route path="categories" element={<Category />} />
                    <Route path="community" element={<CommunityAdmin />} />
                    <Route path="receipts" element={<ReceiptsAdmin />} />
                    <Route path="pix" element={<PixPageAdmin />} />
                    <Route path="evolution" element={<EvolutionManager />} />
                    <Route path="event-type" element={<EventTypes />} />
                    <Route path="kommo-config" element={<KommoConfig />} />
                    <Route path="kommo-import" element={<KommoImport />} />
                    <Route
                      path="welcome-manager"
                      element={<WelcomeManager />}
                    />
                  </Route>
                ) : (
                  <Route path="dashboard" element={<UserDashboard />}>
                    <Route index element={<Welcome />} />
                    <Route path="welcome" element={<Welcome />} />
                    <Route path="events" element={<Events />} />
                    <Route
                      path="pre-subscriptions"
                      element={<PreSubscriptions />}
                    />
                    <Route path="subscriptions" element={<Subscriptions />} />
                    <Route path="documents" element={<Documents />} />
                    <Route path="receipts" element={<Receipts />} />
                    <Route path="gallery" element={<GalleryUser />} />
                    <Route path="education" element={<EducationUser />} />
                    <Route path="commissions" element={<Commissions />} />
                    <Route path="community" element={<CommunityUser />} />
                  </Route>
                )}
              </Route>
              <Route path="*" element={<NotFound />} />
            </Switch>
            <div className="hidden lg:block fixed bottom-4 right-4 z-40 pointer-events-none">
              <div className="pointer-events-auto flex flex-col items-end gap-2">
                <a
                  href="https://wa.me/5511919873660"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp Praceria"
                  className="w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow"
                >
                  <WhatsappRounded width={40} height={40} />
                </a>
                <img
                  src={logo}
                  alt="Praceria"
                  className="h-14 w-auto opacity-90"
                />
              </div>
            </div>
          </ConfirmProvider>
        </ToastProvider>
      </ThemeContainer>
    </>
  );
}
